import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';

import { useAppDispatch, useAppSelector } from '../../../hooks';
import { IDocument } from "../../../models/documents";
import { deletePersonalDocument, getPersonalDocuments, removeOneDocument } from '../../../store';
import { deleteDocument, getDocuments } from '../../../store/thunks/commonDocumentsThunk';
import { cancelBtn, saveBtn } from '../../../styles/MUIStyles';
import ButtonWithProgress from '../../../ui/ButtonWithProgress';
import { ETextVariant, Text } from '../../../ui/Text/Text';
import { sendNotification } from '../../../ui/Toast';

import styles from './styles.module.css';

interface DeleteFileProps {
    id: number;
    originalFileName: string;
    isPersonal: boolean;
    setIsOpenDeleteFile: (isOpenEditFile: boolean) => void;
    setEdited?: (edited: IDocument[]) => void;
}

export const DeleteFile: FC<DeleteFileProps> = ({ id, setIsOpenDeleteFile, originalFileName, isPersonal, setEdited }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { page, pageSize } = useAppSelector(state => state.commonDocuments);

    const save = async () => {
        if (typeof id === 'number') {
            try {
                await dispatch(
                    isPersonal
                        ? deletePersonalDocument({ id })
                        : deleteDocument({ id })
                );

                setIsOpenDeleteFile(false);

                if (isPersonal) {
                    await dispatch(getPersonalDocuments());
                } else {
                    await dispatch(getDocuments({
                        page,
                        pageSize,
                    }));
                }

                sendNotification(t('statuses.Success'), 'success');
            } catch (e) {
                console.log(e);
                sendNotification(t('statuses.Error'), 'error');
            }
        } else {
            dispatch(removeOneDocument(id));
            setEdited?.([]);
        }
    };


    return (
        <div>
            <div style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'white',
                textAlign: 'center',
                padding: '20px',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                borderRadius: '8px',
            }}>
                <Text
                    style={{
                        marginBottom: 24
                    }}
                    variant={ETextVariant.REGULAR}>
                    {`
                    ${t('notifications.areYouSure')}
                    ${t('buttons.DeleteDoc').toLowerCase()}
                    ${originalFileName}?
                    `}
                </Text>
                <ButtonWithProgress
                    onClick={save}
                    loading={false}
                    disabled={false}
                    type="submit"
                    variant="contained"
                    sx={saveBtn}
                >
                    {t('buttons.Delete')}
                </ButtonWithProgress>

                <Button
                    variant="text"
                    onClick={() => setIsOpenDeleteFile(false)}
                    sx={cancelBtn}
                >
                    {t('buttons.Cancel')}
                </Button>
            </div>
        </div>
    );
};
